import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediaService } from 'src/app/service/media/media.service';
@Component({
  selector: 'app-service-prompt',
  templateUrl: './service-prompt.component.html',
  styleUrls: ['./service-prompt.component.scss'],
})
export class ServicePromptComponent implements OnInit {
  @Input() required: boolean;
  @Input() label: string;
  @Input() id: string;
  @Input() name: string;
  @Input() serviceInfo: any;
  @Input() disable: boolean = false;
  @Input() datePrompt: boolean = false;
  @Input() attachmentData: Array<any>;
  @Output() update = new EventEmitter<any>();
  @Output() upload = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  dialogRecord: any = {};
  date: Date;

  get allowedDocumentType(): string {
    return ['.pdf', '.doc', '.PDF', '.docx', '.xlsx', '.xls', '.txt', '.csv'].join(',');
  }

  constructor(private mediaService: MediaService) { }

  ngOnInit(): void {
    if (this.serviceInfo) {
      this.date = this.serviceInfo.date && new Date(this.serviceInfo.date);
    }
  }

  handleUpdate(event: any): void {
    this.update.emit({
      required: this.required,
      date: this.date,
    });
  }

  handleDelete(id: number): void {
    this.delete.emit(id);
  }

  updateVal(value: boolean) {
    this.required = value;
  }

  captureFile(event: any): void {
    this.upload.emit(event);
  }

  captureDate(event: any): void {
    // TODO: do something here to capture the date from the user
    this.handleUpdate(event);
  }
}
